import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, Router } from '@angular/router';
import { FeatureFlag } from '@core/enums';
import { PermissionUtils } from '@core/utils/permission.utils';
import { Store } from '@ngxs/store';
import { AccountState } from '@state/account/state';
import { UserState } from '@state/user/state';
import { ObjectsManagerState } from 'app/modules/settings/objects-manager/state/state';

@Injectable({
  providedIn: 'root',
})
export class ViewCustomObjectsGuard implements CanActivate {
  constructor(
    private store: Store,
    private router: Router,
  ) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    const customObject =
      route.parent?.data?.customObject ??
      this.store.selectSnapshot(ObjectsManagerState.get).find((x) => x.id === +route.params.id);

    if (!customObject) {
      this.router.navigate(['/projects']);
      return false;
    }

    const newPermissionsEnabled = this.store.selectSnapshot(AccountState.isFeatureEnabled(FeatureFlag.NEW_PERMISSIONS));
    let hasPermission = true;
    if (newPermissionsEnabled) {
      const permissions = PermissionUtils.generateCustomObjectPermissions(customObject.name);
      hasPermission = this.store.selectSnapshot(UserState.hasPermission(permissions.VIEW));
    }

    if (!hasPermission) {
      this.router.navigate(['/projects']);
    }
    return hasPermission;
  }
}
